import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function LinkedInIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M8.25131 4.97282C8.25131 5.94722 7.46891 6.73442 6.49931 6.73442C5.53451 6.73442 4.74731 5.94242 4.74731 4.97282C4.74731 4.00322 5.52971 3.20642 6.49931 3.20642C7.46891 3.20642 8.25131 3.99842 8.25131 4.97282Z" fill="currentColor"/>
      <path d="M8.00171 8.00159H5.00171V18.9984H8.00171V8.00159Z" fill="currentColor"/>
      <path d="M20.0018 12.2448V18.9984H17.0018V13.3968C17.0018 10.0272 13.0034 10.2816 13.0034 13.3968V19.0032H10.0034V8.00162H13.0034V9.76802C14.4002 7.18082 20.0018 6.98882 20.0018 12.2448Z" fill="currentColor"/>
    </SvgIcon>
  );
}
